import { Card, CardActionArea, CardHeader } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DisplayedCollection } from "../../app/backendTypes";
import Avatar from "../common/Avatar";

export default function DatasetsCard(props: {
  displayedCollection: DisplayedCollection;
}) {
  const { displayedCollection } = props;

  return (
    <Card>
      <CardActionArea
        component={RouterLink}
        to={`/datasets/${displayedCollection.id}`}
      >
        <CardHeader
          title={displayedCollection.info.display_name}
          subheader={displayedCollection.info.short_desc}
          avatar={
            <Avatar
              alt={displayedCollection.info.display_name}
              src={displayedCollection.info.avatar}
            />
          }
        />
      </CardActionArea>
    </Card>
  );
}
